// src/components/CalculationTypes.js
import React from 'react';
import { Link } from 'react-router-dom';

const CalculationTypes = () => {
    return (
        <div className="h-screen flex items-center justify-center bg-light-brown text-dark-gray">
            <div className="max-w-2xl mx-auto p-8">
                <h2 className="text-4xl font-bold text-center mb-4">Generate Report</h2>
                <div className="text-center space-y-4">
                    <Link to="/user-info/stackreport" className="block bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                        AIR POLLUTANT EMISSION REPORT
                    </Link>
                    {/* <Link to="/details/subtract" className="block bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                        Subtraction
                    </Link> */}
                    {/* Add more calculation types as needed */}
                </div>
            </div>
        </div>
    );
};

export default CalculationTypes;